import React from "react";
import { getFileExtension, getFileKind } from "../../utils/helpers";

const EXTENSION_COLORS = [
  { exts: ["pdf"], className: "bg-red-50 text-red-600" },
  { exts: ["doc", "docx", "odt", "rtf", "txt"], className: "bg-blue-50 text-blue-600" },
  { exts: ["xls", "xlsx", "ods", "csv"], className: "bg-green-50 text-green-600" },
  { exts: ["ppt", "pptx", "odp"], className: "bg-orange-50 text-orange-600" },
  { exts: ["zip", "rar", "7z"], className: "bg-yellow-50 text-yellow-700" },
];

const KIND_COLORS = {
  image: "bg-sky-50 text-sky-600",
  video: "bg-purple-50 text-purple-600",
  audio: "bg-pink-50 text-pink-600",
};

const SIZES = {
  sm: "w-8 h-8 rounded-md text-[9px]",
  md: "w-10 h-10 rounded-lg text-[10px]",
  lg: "w-16 h-16 rounded-2xl text-sm",
};

const FileTypeBadge = ({ file, size = "md", className = "" }) => {
  const ext = getFileExtension(file);
  const color =
    EXTENSION_COLORS.find((c) => c.exts.includes(ext))?.className ||
    KIND_COLORS[getFileKind(file)] ||
    "bg-gray-100 text-gray-600";

  return (
    <span
      className={`flex items-center justify-center flex-shrink-0 font-bold uppercase tracking-wide ${SIZES[size]} ${color} ${className}`}
    >
      {(ext || "file").slice(0, 4)}
    </span>
  );
};

export default FileTypeBadge;
